import { AxiosInstance } from 'axios';
import type { operations } from '@/api/generated/openapi';
import baseAxios from '@/helpers/forms/axios';

export type PrintOrderShippingLabelsPath = operations['print-order-shipping-labels']['parameters']['path'];
export type PrintOrderShippingLabelsResponse = operations['print-order-shipping-labels']['responses']['200']['content']['application/json'];

export type VoidOrderLabelsPath = operations['void-order-labels']['parameters']['path'];
export type VoidOrderLabelsResponse = operations['void-order-labels']['responses']['200']['content']['application/json'];

export type UploadOrderShippingLabelPath = operations['upload-order-shipping-label']['parameters']['path'];
export type UploadOrderShippingLabelRequest = operations['upload-order-shipping-label']['requestBody']['content']['multipart/form-data'];
export type UploadOrderShippingLabelResponse = operations['upload-order-shipping-label']['responses']['201']['content']['application/json'];

// The spec types the multipart binary part as a string; in the browser it is the
// File appended to the FormData, which keeps its name, type and bytes.
export type UploadOrderShippingLabelForm = Omit<UploadOrderShippingLabelRequest, 'file'> & { file: File };

interface OrderLabelsApiReturn {
    printShippingLabels: (orderId: PrintOrderShippingLabelsPath['order']) => Promise<void>
    voidLabels: (orderId: VoidOrderLabelsPath['order']) => Promise<void>
    uploadShippingLabel: (orderId: UploadOrderShippingLabelPath['order'], file: File) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): OrderLabelsApiReturn => ({
    printShippingLabels: async (orderId: PrintOrderShippingLabelsPath['order']): Promise<void> => {
        await axios.post<PrintOrderShippingLabelsResponse>(`/api/orders/${orderId}/printShippingLabels`);
    },

    voidLabels: async (orderId: VoidOrderLabelsPath['order']): Promise<void> => {
        await axios.post<VoidOrderLabelsResponse>(`/api/orders/${orderId}/voidLabels`);
    },

    uploadShippingLabel: async (orderId: UploadOrderShippingLabelPath['order'], file: File): Promise<void> => {
        const form: UploadOrderShippingLabelForm = { file };
        const data = new FormData();
        data.append('file', form.file);

        await axios.post<UploadOrderShippingLabelResponse>(`/api/orders/${orderId}/uploadShippingLabel`, data);
    },
});
